import { Component, OnInit } from '@angular/core';
import { Platform } from '@ionic/angular';
import { SplashScreen } from '@awesome-cordova-plugins/splash-screen/ngx';
import { StatusBar } from '@awesome-cordova-plugins/status-bar/ngx';
import { SwUpdate } from '@angular/service-worker';
import { Network,ConnectionStatus } from '@capacitor/network';
import { NetworkConnectionModel } from 'src/app/models/NetworkConnectionModel/NetworkConnection';
import { NetworkestatusProvider } from './services/networkestatus/networkestatus';
import { LocalDataService } from 'src/app/services/almacenamiento/local-data.service';
import { SettingsApp } from 'src/app/models/ajustes-data.model';
import { loadingController } from '@ionic/core';


@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent implements OnInit {

  dark = false;
  _networkStatus:ConnectionStatus;

  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    private swUpdate: SwUpdate,
    private _LocalDataService : LocalDataService,
    private NetworkestatusProvider : NetworkestatusProvider
  ) {
    this.initializeApp();
  }

  ngOnInit(){

    if(Network){
      Network.getStatus().then((status)=>{
        this._networkStatus = status;
      })
    }

    Network.addListener("networkStatusChange",async (status) => {
          
      this._networkStatus=status;
      const NetworkConnection = await this._LocalDataService.consultarLlave<NetworkConnectionModel>("NetworkStatus")

      const loading = await loadingController.create({
        message: "Espere... se perdio la conexion a internet"
      });
      
      if(!this._networkStatus.connected && NetworkConnection == null){
        
        const ajustes = await this._LocalDataService.consultarLlave<SettingsApp>('ajustes');

        let opBitacoraNetworkConnection: NetworkConnectionModel = {	
          strEvento : "Desconexión",	
          strDispositivo: ajustes.strDispositivo,	
          strDireccionMac:ajustes.strDispositivo+" : "+ajustes.strPortName+" : "+ new Date().toLocaleString('es-MX',{ timeZone: 'America/Mexico_City'}),	
          strDireccionIp:ajustes.strIP,
          blnActivo:true,
          IdUsuarioAlta:null,	
          dteFechaAlta: null,
          dteFechaActualizacion:null,
          IdUsuarioActualizacion:null
        }


        loading.present() 
        
        this._LocalDataService.guardarLlave("NetworkStatus",opBitacoraNetworkConnection)

      }else if(this._networkStatus.connected && NetworkConnection != null){ 

        loadingController.dismiss();

        if(NetworkConnection != null ){
          let result = null;
          this.NetworkestatusProvider.saveBitacoraNetworkConnection(NetworkConnection).subscribe(x => {
            if(x){
              result = x
      
              this._LocalDataService.eliminarLlave("NetworkStatus")
            }
          },
          async error => {
            console.log("Error => ",error);
          });
        }
      }
    })
  }


  initializeApp() {

    this.platform.ready().then(async () => {

      if (this.platform.is('cordova')) {
        this.statusBar.styleDefault();
        this.splashScreen.hide();
      }

      if (!this.swUpdate.isEnabled) {
        // console.log('swUpdate Enabled ? Nope :(');
      } else {
        // console.log('swUpdate Enabled ? Yes :)');
        if (this.swUpdate.available) {
          this.swUpdate.available.subscribe(() => {
            if (confirm('A new version is available. Load it?'))
              window.location.reload();
          });
        }
      }

    });
  }

}
